var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCheckCircle, faDownload, faExclamationCircle, faFileImport, faLink, faSpinner, } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BButton, BButtonGroup, BButtonToolbar, BCard, BCollapse, BLink, BTable } from "bootstrap-vue";
import { computed, ref } from "vue";
import {} from "./models/exportRecordModel";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ExportRecordTable',
    props: {
        records: null
    },
    emits: ["onReimport", "onDownload", "onCopyDownloadLink"],
    setup(__props, { emit }) {
        const props = __props;
        library.add(faCheckCircle, faDownload, faExclamationCircle, faFileImport, faLink, faSpinner);
        const fields = [
            { key: "elapsedTime", label: "Exported" },
            { key: "format", label: "Format" },
            { key: "expires", label: "Expires" },
            { key: "isUpToDate", label: "Up to date", class: "text-center" },
            { key: "isReady", label: "Ready", class: "text-center" },
            { key: "actions", label: "Actions" },
        ];
        const isExpanded = ref(false);
        const title = computed(() => (isExpanded.value ? `Hide old export records` : `Show old export records`));
        function reimportObject(record) {
            return __awaiter(this, void 0, void 0, function* () {
                emit("onReimport", record);
            });
        }
        function downloadObject(record) {
            emit("onDownload", record);
        }
        function copyDownloadLink(record) {
            emit("onCopyDownloadLink", record);
        }
        return { __sfc: true, props, emit, fields, isExpanded, title, reimportObject, downloadObject, copyDownloadLink, faCheckCircle, faDownload, faExclamationCircle, faFileImport, faLink, faSpinner, FontAwesomeIcon, BButton, BButtonGroup, BButtonToolbar, BCard, BCollapse, BLink, BTable };
    }
});
